export const setLanguage = (language) => {
	const action = {
		type: "SET_LANGUAGE",
		payload: language
	}
	return action
}
